import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'userGroup'
})
export class ApplicationNamePipe implements PipeTransform {

  transform(applicationsArray: any, currentApplication?: any): any {
    var userGroup = "";
    applicationsArray.forEach(app => {
      if(app.application==currentApplication)
      {
        userGroup = app.userGroup;
      }
    });
    return userGroup;
  }

}
